import Suppliers from '@features/supplier/component/Suppliers';

const SupplierList = ({ requestFrom, additionalFilters }) => {
	return <Suppliers requestFrom={requestFrom} additionalFilters={additionalFilters} />;
};

export default SupplierList;
